<div class="hero-about">
    <img src="assets/img/hero-about/AdobeStock_430677913.png" alt="Hero Image">
    <div class="hero-overlay"></div>
    <div class="hero-content">
        <h1 class="hero-title">About Us</h1>
    </div>
</div>